import ScalarPopover_default from "./ScalarPopover.vue.js";
export { ScalarPopover_default as ScalarPopover };
